<div class="oi-notifications-table">
    <div class="oi-notifications-table-header">
        <div
            class="oi-notifications-table-header-cell tapestry-body body--sm bold"
        >
            {{ 'label.common-terms.recipient' | translate }}
        </div>
        <div
            class="oi-notifications-table-header-cell tapestry-body body--sm bold"
        >
            {{ 'label.common-terms.none' | translate }}
        </div>
        <div
            class="oi-notifications-table-header-cell tapestry-body body--sm bold"
        >
            {{ 'client-core.oi-notifications.completion-email' | translate }}
        </div>
        <div
            class="oi-notifications-table-header-cell tapestry-body body--sm bold"
        >
            {{ 'client-core.oi-notifications.email-and-ba-report' | translate }}
        </div>
    </div>
    <div class="oi-notifications-table-body">
        <div class="oi-notifications-table-body-row">
            <mat-radio-group
                [ngModel]="notifyLinkOwner"
                (ngModelChange)="onLinkOwnerChange($event)"
            >
                <div
                    class="oi-notifications-table-body-row-cell tapestry-body body--sm"
                >
                    {{ 'client-core.oi-notifications.link-owner' | translate }}
                </div>
                @for (option of options; track option) {
                    <div class="oi-notifications-table-body-row-cell">
                        <mat-radio-button [value]="option"></mat-radio-button>
                    </div>
                }
            </mat-radio-group>
        </div>
        <div class="oi-notifications-table-body-row">
            <mat-radio-group
                [ngModel]="notifyStakeholders"
                (ngModelChange)="onStakeholderChange($event)"
            >
                <div
                    class="oi-notifications-table-body-row-cell tapestry-body body--sm"
                >
                    {{ 'common.stakeholders' | translate }}
                </div>
                @for (option of options; track option) {
                    <div class="oi-notifications-table-body-row-cell">
                        <mat-radio-button [value]="option"></mat-radio-button>
                    </div>
                }
            </mat-radio-group>
        </div>
        <div class="oi-notifications-table-body-row">
            <mat-radio-group
                [ngModel]="notifyAssessmentTaker"
                (ngModelChange)="onAssessmentTakerChange($event)"
            >
                <div
                    class="oi-notifications-table-body-row-cell tapestry-body body--sm"
                >
                    {{
                        'client-core.oi-notifications.assessment-taker'
                            | translate
                    }}
                </div>
                @for (option of options; track option) {
                    <div class="oi-notifications-table-body-row-cell">
                        <mat-radio-button
                            color="primary"
                            [value]="option"
                        ></mat-radio-button>
                    </div>
                }
            </mat-radio-group>
        </div>
    </div>
</div>
